import React, { useEffect, useState, useRef } from "react";
import {
  validateAlphanumeric,
  validateAadhar,
  validateEmail,
  validateOnlyLetters,
} from "../../utils/validation";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AdmRegistration.css";
import { useNavigate } from "react-router-dom";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchReligions from "../../hooks/useFetchReligions";
import useFetchHouses from "../../hooks/useFetchHouses";
import useFetchCategories from "../../hooks/useFetchCategories ";
import useFetchNationalities from "../../hooks/useFetchNationalities";
import useFetchSections from "../../hooks/useFetchSections";
import useFetchLanguages from "../../hooks/useFetchLanguages";
import useFetchBloodGroups from "../../hooks/useFetchBloodGroups";
import { useParams } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import {
  fileToDataUrl,
  prepareUploadFile,
  PROFILE_UPLOAD_OPTIONS,
} from "../../utils/uploadUtils";

const AdmAttendanceEntry = ({
  formData,
  setFormData,
  frontCover,
  setFrontCover,
}) => {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [studentBasicDetails, setStudentBasicDetails] = useState(null);
  const navigate = useNavigate();
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  // const [frontCover, setFrontCover] = useState(null);
  const [selectedSection, setSelectedSection] = useState(
    localStorage.getItem("selectedSectionId") || ""
  );

  const [errors, setErrors] = React.useState({
    barcode: "",
    registration_no: "",
    school_admission_no: "",
    username: "",
    cbse_reg_no: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    childreninfamily: "",
    studentaadharno: "",
    email: "",
    rollno: "",
  });
  const {
    houses,
    loading: loadingHouses,
    error: errorHouses,
  } = useFetchHouses();
  const {
    categories,
    loading: loadingCategories,
    error: errorCategories,
  } = useFetchCategories();
  const {
    nationalities,
    loading: loadingNationalities,
    error: errorNationalities,
  } = useFetchNationalities();
  // const [selectedClass, setSelectedClass] = useState("");
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [selectedClass, setSelectedClass] = useState(
    localStorage.getItem("selectedClassId") || ""
  );

  const { data: languages, loading, error } = useFetchLanguages();
  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);
  const {
    bloodGroups,
    loading: loadingBloodGroups,
    error: errorBloodGroups,
  } = useFetchBloodGroups();
  const {
    religions,
    loading: religionLoading,
    error: religionError,
  } = useFetchReligions();

  // useEffect(() => {
  //   if (id) {
  //     fetch(
  //       `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.message === "success") {
  //           if (!formData.first_name) {
  //             const studentDetails = data.data.student_basic_details;

  //             const classId = studentDetails.classId?.toString() || "";
  //             const sectionId = studentDetails.sectionId?.toString() || "";

  //             // Convert ISO to mm/dd/yyyy format
  //             const isoDate = studentDetails.date_of_admission;
  //             const formattedDate = isoDate
  //               ? new Date(isoDate).toISOString().split("T")[0]
  //               : "";

  //             setFormData((prevFormData) => ({
  //               ...prevFormData,
  //               ...studentDetails,
  //               date_of_admission: formattedDate, //  set formatted yyyy-mm-dd for input[type=date]
  //               addmitted_class: classId,
  //               addmitted_section: sectionId,
  //               profile_pic: prevFormData.profile_pic,
  //             }));

  //             //  Set dropdowns
  //             setSelectedClass(classId);
  //             setSelectedSection(sectionId);

  //             localStorage.setItem("selectedClassId", classId);
  //             localStorage.setItem("selectedSectionId", sectionId);

  //             setIsDisabled(true);
  //           }
  //         } else {
  //           setErrors({ api: "Failed to fetch data" });
  //         }
  //         setIsDataLoading(false);
  //       })
  //       .catch((error) => {
  //         setErrors({ api: error.message });
  //         setIsDataLoading(false);
  //       });
  //   }
  // }, [id, setFormData, formData.first_name]);

  useEffect(() => {
    if (id) {
      fetch(
        `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
      )
        .then((response) => response.json())
        .then(async (data) => {
          if (data.message === "success") {
            if (!formData.first_name) {
              const studentDetails = data.data.student_basic_details;
              const classId = studentDetails.addmitted_class?.toString() || "";
              const sectionId =
                studentDetails.addmitted_section?.toString() || "";

              // Convert ISO to yyyy-mm-dd format
              const formattedDate = studentDetails.date_of_admission
                ? new Date(studentDetails.date_of_admission)
                    .toISOString()
                    .split("T")[0]
                : "";

              // const updatedFormData = {
              //   ...studentDetails,
              //   date_of_admission: formattedDate,
              //   addmitted_class: classId,
              //   addmitted_section: sectionId,
              // };

              const updatedFormData = {
                ...studentDetails,
                date_of_admission: formattedDate,
                addmitted_class: classId, // raw ID for saving
                addmitted_section: sectionId, // raw ID for saving

                // ✅ Extra fields for React-Select display
                admitted_class_option: classId
                  ? {
                      value: classId,
                      label:
                        classes.find((cls) => cls.id.toString() === classId)
                          ?.classname ||
                        studentDetails.classname ||
                        "Select Class",
                    }
                  : null,
                admitted_section_option: sectionId
                  ? {
                      value: sectionId,
                      label:
                        sections.find(
                          (sec) => sec.section_id.toString() === sectionId
                        )?.sectionname ||
                        studentDetails.sectionname ||
                        "Select Section",
                    }
                  : null,
              };

              // ✅ If profile_pic is a string URL, fetch and convert to base64
              if (
                studentDetails.profile_pic &&
                typeof studentDetails.profile_pic === "string"
              ) {
                try {
                  const response = await fetch(studentDetails.profile_pic);
                  const blob = await response.blob();
                  const base64Data = await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                  });

                  sessionStorage.setItem("profile_pic_base64", base64Data);
                  sessionStorage.setItem("profile_pic_name", "profile.jpg");
                  sessionStorage.setItem("profile_pic_type", blob.type);
                  setFrontCover(base64Data);
                  updatedFormData.profile_pic_preview = base64Data;
                } catch (error) {
                  console.warn("Failed to load profile_pic:", error);
                  setFrontCover(studentDetails.profile_pic);
                  updatedFormData.profile_pic_preview = studentDetails.profile_pic;
                }
              }

              setFormData((prevFormData) => ({
                ...prevFormData,
                ...updatedFormData,
              }));

              setSelectedClass(classId);
              setSelectedSection(sectionId);

              localStorage.setItem("selectedClassId", classId);
              localStorage.setItem("selectedSectionId", sectionId);
              setIsDisabled(true);
            }
          } else {
            setErrors({ api: "Failed to fetch data" });
          }
          setIsDataLoading(false);
        })
        .catch((error) => {
          setErrors({ api: error.message });
          setIsDataLoading(false);
        });
    }
  }, [id]);

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const previewUrl = URL.createObjectURL(file);

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       profile_pic: file,
  //       profile_pic_preview: previewUrl,
  //     }));

  //     setFrontCover(previewUrl);
  //   }
  // };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const previewUrl = URL.createObjectURL(file);

  //     setFrontCover(previewUrl); // for preview

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       profile_pic: file, // keep the File object directly
  //       profile_pic_preview: previewUrl,
  //     }));
  //   }
  // };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const previewUrl = URL.createObjectURL(file);
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       profile_pic: file,
  //       profile_pic_preview: previewUrl, // :white_check_mark: store preview in formData to persist it
  //     }));
  //     setFrontCover(previewUrl); // :white_check_mark: still show it immediately in UI
  //   }
  // };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    try {
      const processedFile = await prepareUploadFile(file, PROFILE_UPLOAD_OPTIONS);
      const base64Data = await fileToDataUrl(processedFile);

      sessionStorage.setItem("profile_pic_base64", base64Data);
      sessionStorage.setItem("profile_pic_name", processedFile.name);
      sessionStorage.setItem("profile_pic_type", processedFile.type);

      setFrontCover(base64Data);
      setFormData((prevData) => ({
        ...prevData,
        profile_pic_preview: base64Data,
      }));
    } catch (error) {
      alert(error.message || "Unable to prepare the selected profile photo.");
      e.target.value = "";
    }
  };

  const handleInputChange = (e) => {
  const { name } = e.target;
  let value = e.target.value;
  const capitalizeName = (text) =>
    text
      .replace(/\s+/g, " ")
      .trimStart()
      .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

  const normalizedValue =
    name === "first_name" || name === "middle_name" || name === "last_name"
      ? capitalizeName(value)
      : value;
  
  const fieldsToValidate = [
    "barcode",
    "registration_no",
    "school_admission_no",
    "username",
    "cbse_reg_no",
    "rollno",
  ];
    if (fieldsToValidate.includes(name)) {
      if (value === "" || validateAlphanumeric(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Only alphanumeric is allowed",
        }));
      }
    }
    // Aadhar validation
    if (name === "studentaadharno") {
      if (value === "" || validateAadhar(value)) {
        if (value.length !== 12) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Aadhar number must be exactly 12 digits",
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
          }));
        }
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Aadhar number must contain only numbers",
        }));
      }
    }
    // Email validation
    if (name === "email") {
      if (value === "" || validateEmail(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Please enter a valid email address",
        }));
      }
    }

    if (
      name === "first_name" ||
      name === "middle_name" ||
      name === "last_name"
    ) {
      if (normalizedValue === "" || validateOnlyLetters(normalizedValue)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Only letters and spaces are allowed",
        }));
      }
    }

    // Category and Class handling for localStorage/sessionStorage
    if (name === "category") {
      localStorage.setItem("selectedCategoryId", value);
      sessionStorage.setItem("CategoryLogic", "true");
      sessionStorage.setItem("ClassLogic", "false");
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: normalizedValue,
    }));
  };
  // const handleClassChange = (e) => {
  //   const classId = e.target.value;
  //   setSelectedClass(classId);
  //   // setFormData((prevData) => ({
  //   //   ...prevData,
  //   //   addmitted_class: classId,
  //   // }));
  //   setFormData((prev) => ({
  //     ...prev,
  //     addmitted_class: e.target.value,
  //   }));
  //   localStorage.setItem("selectedClassId", classId);
  // };

  // const handleSectionChange = (e) => {
  //   const sectionId = e.target.value;
  //   // setFormData((prevData) => ({
  //   //   ...prevData,
  //   //   addmitted_section: sectionId,
  //   // }));
  //   setFormData((prev) => ({
  //     ...prev,
  //     addmitted_section: e.target.value,
  //   }));
  // };

  // const handleClassChange = (e) => {
  //   const classId = e.target.value;
  //   setSelectedClass(classId);
  //   setFormData((prev) => ({
  //     ...prev,
  //     addmitted_class: classId,
  //   }));
  //   localStorage.setItem("selectedClassId", classId);
  //   sessionStorage.setItem("selectedClassId", classId); // ✅ Add this
  // };

  useEffect(() => {
    // Clear ClassLogic on page refresh/load
    sessionStorage.removeItem("ClassLogic");
  }, []);

  useEffect(() => {
    // Clear ClassLogic on page refresh/load
    sessionStorage.removeItem("CategoryLogic");
  }, []);

  // 🔄 Sync category change to localStorage + FeeDetails
  useEffect(() => {
    if (formData.category) {
      setFormData((prev) => ({
        ...prev,
        category: formData.category,
      }));
      localStorage.setItem("selectedCategoryId", formData.category);
    } else {
      localStorage.removeItem("selectedCategoryId");
    }
  }, [formData.category]);

  const handleClassChange = (e) => {
    const classId = e.target.value;
    const selectedClass = classes.find(
      (classItem) => String(classItem.id) === String(classId)
    );
    setSelectedClass(classId);
    setFormData((prev) => ({
      ...prev,
      addmitted_class: classId,
      classname: selectedClass?.classname || "",
    }));

    localStorage.setItem("selectedClassId", classId);
    sessionStorage.setItem("selectedClassId", classId);

    if (classId) {
      sessionStorage.setItem("ClassLogic", "true"); // ✅ Set when a class is selected
      sessionStorage.setItem("CategoryLogic", "false");
    }
  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      addmitted_section: sectionId,
    }));
    localStorage.setItem("selectedSectionId", sectionId); // Optional
    sessionStorage.setItem("selectedSectionId", sectionId); // ✅ Add this
  };

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];
  const statusOptions = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card-body">
            <div className=" row mt-3 mx-2">
              <div className="col-12 custom-section-box">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                  <div className="row flex-grow-1 mt-2 ">
                    <div className="col-12 col-md-4 mb-2 ">
                      <label htmlFor="admission-no" className="form-label">
                        Admission No<span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="text"
                        id="admission-no"
                        className="form-control detail"
                        placeholder="Enter admission no"
                        name="last_name"
                        value={formData.admission_no}
                        onChange={handleInputChange}
                        disabled
                      />{" "}
                    </div>
                    {/* <div className="col-12 col-md-3 mb-4 ">
                      <label htmlFor="parent-id" className="form-label">
                        Parent ID<span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="text"
                        id="parent-id"
                        className="form-control detail"
                        placeholder="Enter parent id"
                        disabled
                      />
                    </div> */}
                    <div className="col-12 col-md-5  ">
                      <label htmlFor="student-name" className="form-label">
                        {" "}
                        Student Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="student-name"
                          className="form-control detail"
                          placeholder="Enter First name"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleInputChange}
                          required
                        />
                        <span style={{ color: "red" }}>*</span>
                        {errors.first_name && (
                          <small style={{ color: "red" }}>
                            {errors.first_name}
                          </small>
                        )}
                        <input
                          type="text"
                          id="student-name"
                          className="form-control detail mx-2"
                          placeholder="Enter middle name"
                          name="middle_name"
                          value={formData.middle_name}
                          onChange={handleInputChange}
                        />{" "}
                        {errors.middle_name && (
                          <small style={{ color: "red" }}>
                            {errors.middle_name}
                          </small>
                        )}
                        <input
                          type="text"
                          id="student-name"
                          className="form-control detail mx-2"
                          placeholder="Enter last name"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleInputChange}
                        />
                        {errors.last_name && (
                          <small style={{ color: "red" }}>
                            {errors.last_name}
                          </small>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="admitted-class" className="form-label">
                        Admitted Class<span style={{ color: "red" }}>*</span>
                      </label>
                      {classLoading ? (
                        <p>Loading classes...</p>
                      ) : classError ? (
                        <p>Error loading classes: {classError}</p>
                      ) : (
                        <select
                          id="admitted-class"
                          className="form-select detail"
                          // value={formData.classId}
                          value={formData.addmitted_class || ""}
                          onChange={handleClassChange}
                          required
                        >
                          <option value="">Select Class</option>
                          {classes.map((classItem) => (
                            <option key={classItem.id} value={classItem.id}>
                              {classItem.classname}
                            </option>
                          ))}
                        </select>
                      )}
                    </div> */}
                    {/* <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="admitted-class" className="form-label">
                        Admitted Class<span style={{ color: "red" }}>*</span>
                      </label>
                      {classLoading ? (
                        <p>Loading classes...</p>
                      ) : classError ? (
                        <p>Error loading classes: {classError}</p>
                      ) : (
                        <select
                          id="admitted-class"
                          className="form-select detail"
                          value={formData.addmitted_class || ""}
                          onChange={handleClassChange}
                          disabled={isDisabled}
                          required
                        >
                          <option value="">Select Class</option>
                          {classes.map((classItem) => (
                            <option key={classItem.id} value={classItem.id}>
                              {classItem.classname}
                            </option>
                          ))}
                        </select>
                      )}
                    </div> */}
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="admitted-class" className="form-label">
                        Admitted Class <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="admitted-class"
                        className="detail"
                        classNamePrefix="admitted-class-select"
                        options={[
                          { value: "", label: "Select Class" },
                          ...classes.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.classname,
                          })),
                        ]}
                        value={
                          formData.addmitted_class
                            ? {
                                value: formData.addmitted_class,
                                label:
                                  classes.find(
                                    (cls) =>
                                      cls.id.toString() ===
                                      formData.addmitted_class.toString()
                                  )?.classname || "Select Class",
                              }
                            : { value: "", label: "Select Class" }
                        }
                        onChange={(selectedOption) =>
                          handleClassChange({
                            target: {
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                        isDisabled={isDisabled}
                      />
                    </div>
                    {/* Admitted Section */}
                    {/* <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="admitted-section" className="form-label">
                        Admitted Section<span style={{ color: "red" }}>*</span>
                      </label>
                      {sectionLoading ? (
                        <p>Loading sections...</p>
                      ) : sectionError ? (
                        <p>Error loading sections: {sectionError}</p>
                      ) : (
                        <select
                          id="admitted-section"
                          className="form-select detail"
                          value={formData.addmitted_section || ""}
                          onChange={handleSectionChange}
                          required
                        >
                          <option value="">Select Section</option>
                          {sections.map((section) => (
                            <option
                              key={section.section_id}
                              value={section.section_id}
                            >
                              {section.sectionname}
                            </option>
                          ))}
                        </select>
                      )}
                    </div> */}
                    {/* 
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="admitted-section" className="form-label">
                        Admitted Section<span style={{ color: "red" }}>*</span>
                      </label>
                      {sectionLoading ? (
                        <p>Loading sections...</p>
                      ) : sectionError ? (
                        <p>Error loading sections: {sectionError}</p>
                      ) : (
                        <select
                          id="admitted-section"
                          className="form-select detail"
                          value={formData.addmitted_section || ""}
                          onChange={handleSectionChange}
                          disabled={isDisabled}
                          required
                        >
                          <option value="">Select Section</option>
                          {sections.map((section) => (
                            <option
                              key={section.section_id}
                              value={section.section_id}
                            >
                              {section.sectionname}
                            </option>
                          ))}
                        </select>
                      )}
                    </div> */}
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="admitted-section" className="form-label">
                        Admitted Section <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="admitted-section"
                        className="detail"
                        classNamePrefix="admitted-section-select"
                        options={[
                          { value: "", label: "Select Section" },
                          ...sections.map((section) => ({
                            value: section.section_id,
                            label: section.sectionname,
                          })),
                        ]}
                        value={
                          formData.addmitted_section
                            ? {
                                value: formData.addmitted_section,
                                label:
                                  sections.find(
                                    (sec) =>
                                      sec.section_id.toString() ===
                                      formData.addmitted_section.toString()
                                  )?.sectionname || "Select Section",
                              }
                            : { value: "", label: "Select Section" }
                        }
                        onChange={(selectedOption) =>
                          handleSectionChange({
                            target: {
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                        isDisabled={isDisabled}
                      />
                    </div>
                    {/* <div className="col-12 col-sm-6 col-md-4 mb-2">
                      <label htmlFor="gender" className="form-label">
                        Gender<span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <select
                        id="gender"
                        name="gender"
                        value={formData.gender}
                        className="form-select detail"
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div> */}
                    <div className="col-12 col-sm-6 col-md-4 mb-4">
                      <label htmlFor="gender" className="form-label">
                        Gender<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="gender"
                        name="gender"
                        options={genderOptions}
                        className="detail"
                        classNamePrefix="gender-dropdown"
                        placeholder="Select Gender"
                        value={genderOptions.find(
                          (option) => option.value === formData.gender
                        )}
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "gender",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="date_of_admission" className="form-label">
                        Date Of Admission{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date_of_admission"
                        className="form-control detail"
                        name="date_of_admission"
                        value={formData.date_of_admission || ""}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="doj" className="form-label">
                        Date Of Join <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="doj"
                        className="form-control detail"
                        name="doj"
                        value={formData.doj || ""}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="rollno" className="form-label">
                        {" "}
                        Roll No{" "}
                      </label>
                      <input
                        type="text"
                        id="rollno"
                        className="form-control detail"
                        placeholder="Enter roll-no"
                        name="rollno"
                        value={formData.rollno}
                        onChange={handleInputChange}
                      />
                      {errors.rollno && (
                        <small style={{ color: "red" }}>{errors.rollno}</small>
                      )}{" "}
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="barcode" className="form-label">
                        Barcode
                      </label>
                      <input
                        type="text"
                        id="barcode"
                        className="form-control detail"
                        placeholder="Enter barcode"
                        name="barcode"
                        value={formData.barcode}
                        onChange={handleInputChange}
                      />
                      {errors.barcode && (
                        <small style={{ color: "red" }}>{errors.barcode}</small>
                      )}
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="registration-no" className="form-label">
                        {" "}
                        Registration No{" "}
                      </label>
                      <input
                        type="text"
                        id="registration-no"
                        className="form-control detail"
                        placeholder="Enter registration no"
                        name="registration_no"
                        value={formData.registration_no}
                        onChange={handleInputChange}
                      />
                      {errors.registration_no && (
                        <small style={{ color: "red" }}>
                          {errors.registration_no}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="cbse-regn-no" className="form-label">
                        {" "}
                        CBSE Regn. No.{" "}
                      </label>
                      <input
                        type="text"
                        id="cbse-regn-no"
                        className="form-control detail"
                        placeholder="Enter CBSE regn. no."
                        name="cbse_reg_no"
                        value={formData.cbse_reg_no}
                        onChange={handleInputChange}
                      />
                      {errors.cbse_reg_no && (
                        <small style={{ color: "red" }}>
                          {errors.cbse_reg_no}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="house" className="form-label">
                        House<span style={{ color: "red" }}>*</span>
                      </label>

                      <Select
                        id="house"
                        name="house"
                        className="detail"
                        classNamePrefix="house-dropdown"
                        placeholder="Select house"
                        options={houses.map((house) => ({
                          value: house.housename,
                          label: house.housename,
                        }))}
                        value={
                          formData.house
                            ? { value: formData.house, label: formData.house }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "house",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="religion" className="form-label">
                        Religion<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="religion"
                        name="religion"
                        className="detail"
                        classNamePrefix="religion-dropdown"
                        placeholder="Select Religion"
                        options={religions.map((religion) => ({
                          value: religion.religioncode,
                          label: religion.religiondescription,
                        }))}
                        value={
                          formData.religion
                            ? {
                                value: formData.religion,
                                label:
                                  religions.find(
                                    (r) => r.religioncode === formData.religion
                                  )?.religiondescription || formData.religion,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "religion",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="category" className="form-label">
                        Category<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="category"
                        name="category"
                        className="detail"
                        classNamePrefix="category-dropdown"
                        placeholder="Select Category"
                        options={categories.map((category) => ({
                          value: category.categorycode,
                          label: category.categoryname,
                        }))}
                        value={
                          formData.category
                            ? {
                                value: formData.category,
                                label:
                                  categories.find(
                                    (c) => c.categorycode === formData.category
                                  )?.categoryname || formData.category,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "category",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="mother-tongue" className="form-label">
                        Mother Tongue<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="mother-tongue"
                        name="nativelanguage"
                        className="detail"
                        classNamePrefix="language-dropdown"
                        placeholder="Select Mother Tongue"
                        options={
                          Array.isArray(languages)
                            ? languages.map((language) => ({
                                value: language.languagecode,
                                label: language.languagedesc,
                              }))
                            : []
                        }
                        value={
                          formData.nativelanguage
                            ? {
                                value: formData.nativelanguage,
                                label:
                                  languages.find(
                                    (lang) =>
                                      lang.languagecode ===
                                      formData.nativelanguage
                                  )?.languagedesc || formData.nativelanguage,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "nativelanguage",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="blood-group" className="form-label">
                        Blood Group<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="blood-group"
                        name="bloodgroup"
                        className="detail"
                        classNamePrefix="blood-dropdown"
                        placeholder="Select Blood Group"
                        options={bloodGroups.map((group) => ({
                          value: group.bloodcode,
                          label: group.blooddesc,
                        }))}
                        value={
                          formData.bloodgroup
                            ? {
                                value: formData.bloodgroup,
                                label:
                                  bloodGroups.find(
                                    (g) => g.bloodcode === formData.bloodgroup
                                  )?.blooddesc || formData.bloodgroup,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "bloodgroup",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="nationality" className="form-label">
                        Nationality<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="nationality"
                        name="nationality"
                        className="detail"
                        classNamePrefix="nationality-dropdown"
                        placeholder="Select Nationality"
                        options={nationalities.map((nat) => ({
                          value: nat.nationalitycode,
                          label: nat.nationalitycode,
                        }))}
                        value={
                          formData.nationality
                            ? {
                                value: formData.nationality,
                                label:
                                  nationalities.find(
                                    (n) =>
                                      n.nationalitycode === formData.nationality
                                  )?.nationalitycode || formData.nationality,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "nationality",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                    </div>
                    {/* <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="status" className="form-label">
                        Status<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="status"
                        className="detail"
                        value={formData.student_status || "ACTIVE"}
                        onChange={handleInputChange}
                        name="student_status"
                        disabled
                      >
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                      </select>
                    </div> */}
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="status" className="form-label">
                        Status<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="status"
                        name="student_status"
                        value={{
                          value: formData.student_status || "ACTIVE",
                          label: formData.student_status || "ACTIVE",
                        }}
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "student_status",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                        options={[
                          { value: "ACTIVE", label: "ACTIVE" },
                          { value: "INACTIVE", label: "INACTIVE" },
                        ]}
                        isDisabled={!isEditMode}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                          control: (provided) => ({
                            ...provided,
                            minHeight: "36px",
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="email" className="form-label">
                        {" "}
                        Email{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder="Enter email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && (
                        <small style={{ color: "red" }}>{errors.email}</small>
                      )}
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="date-of-birth" className="form-label">
                        Date Of Birth <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date-of-birth"
                        className="form-control detail"
                        name="dob"
                        value={formData.dob || ""}
                        onChange={handleInputChange}
                        required
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label
                        htmlFor="children-in-family"
                        className="form-label"
                      >
                        {" "}
                        Children in Family{" "}
                      </label>
                      <input
                        type="text"
                        id="children-in-family"
                        className="form-control detail"
                        placeholder="Enter children in family"
                        name="childreninfamily"
                        value={formData.childreninfamily}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          handleInputChange({
                            target: { name: "childreninfamily", value },
                          });
                        }}
                      />{" "}
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="student-aadhar-no" className="form-label">
                        {" "}
                        Student Aadhar No<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="student-aadhar-no"
                        className="form-control detail"
                        placeholder="Enter student aadhar no"
                        name="studentaadharno"
                        value={formData.studentaadharno}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          handleInputChange({
                            target: { name: "studentaadharno", value },
                          });
                        }}
                        maxLength={12}
                      />
                      {errors.studentaadharno && (
                        <small style={{ color: "red" }}>
                          {errors.studentaadharno}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                      <label htmlFor="user-name" className="form-label">
                        User Name
                      </label>
                      <input
                        type="text"
                        id="user-name"
                        className="form-control detail"
                        placeholder="Enter user name"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                      />
                      {errors.username && (
                        <small style={{ color: "red" }}>
                          {errors.username}
                        </small>
                      )}
                    </div>
                    {/* <div className="col-12 col-md-4 mb-2">
                      <label htmlFor="remarks" className="form-label">
                        {" "}
                        Remarks{" "}
                      </label>
                      <input
                        type="text"
                        id="remarks"
                        className="form-control detail"
                        placeholder="Enter remarks"
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleInputChange}
                      />
                    </div> */}
                    {/* <div className="col-12 col-md-6 col-lg-3">
                      <label htmlFor="profilePic" className="form-label">
                        Profile Picture
                      </label>
                      <input
                        type="file"
                        // name="profile_pic"
                        className="form-control detail"
                        id="profilePic"
                        // accept="image/*"
                        onChange={handleFileChange}
                      />
                    </div>
                    {frontCover && (
                      <div className="mt-3">
                        <img
                          src={frontCover}
                          alt="Profile Picture Preview"
                          style={{
                            width: "120px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )} */}
                    <div className="col-12 col-md-6 col-lg-3">
                      <label htmlFor="profilePic" className="form-label">
                        Profile Picture
                      </label>
                      <input
                        type="file"
                        className="form-control detail"
                        id="profilePic"
                        onChange={handleFileChange}
                      />
                    </div>
                    {frontCover && (
                      <div className="mt-3">
                        <img
                          src={frontCover}
                          alt="Profile Picture Preview"
                          style={{
                            width: "120px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdmAttendanceEntry;
